import { IconButton, Tooltip } from "@mui/material";
import SupportAgent from "@mui/icons-material/SupportAgent";
import { useTranslation } from "react-i18next";

const ChatwootButton = ({ inline = false }) => {
  const { t } = useTranslation();

  const toggleChatwoot = () => {
    if (window.$chatwoot) {
      window.$chatwoot.toggle();
    } else {
      console.warn("Chatwoot is not loaded");
    }
  };

  return (
    <Tooltip title={t("support.getSupport")} placement={inline ? "top" : "left"}>
      <IconButton
        className={`chatwoot-floating-btn${inline ? " chatwoot-inline-btn" : ""}`}
        onClick={toggleChatwoot}
        aria-label={t("support.getSupport")}
      >
        <SupportAgent />
      </IconButton>
    </Tooltip>
  );
};

export default ChatwootButton;

